import { forwardRef, type Ref, type SVGProps } from "react";
const IconHideOutlineSVG = ({
  children,
  ...rest
}: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 32 32" ref={ref} {...rest}>{children}<path fill="currentColor" d="M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2M6.85 23.74A12 12 0 0 1 23.74 6.85zM16 28a11.9 11.9 0 0 1-7.74-2.85L25.15 8.26A12 12 0 0 1 16 28" /></svg>;
const ForwardRef = forwardRef(IconHideOutlineSVG);
ForwardRef.displayName = "IconHideOutline";
export { ForwardRef as IconHideOutline };